export default "/_next/static/images/service-walk-desktop-2x-b04adcfb4a03161514cd374d17980db1.jpg";